import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash";
import { Container, Form, Button, Icon, Divider, Grid, Segment, Header, Table, Dropdown } from "semantic-ui-react";
import * as TENANT_CLOUD_ACTIONS from "../../../actions/tenantCloudActions";

export function TenantCloudDetails(props) {
    const [state, setState] = useState({
        tenantCloud: {
            ...props.tenantCloud,
            tenants: props.tenantCloud?.tenants || [],
            questionnaires: props.tenantCloud?.questionnaires || []
        }
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    useEffect(() => {
        // props.fetchTenantsAction();
    }, [props.tenant]);

    const onSubmit = async () => {
        await props.saveTenantCloudAction(state.tenantCloud, props.isNew, props.onComplete);

        if (_.isEmpty(props.onComplete)) {
            props.onComplete();
        }
    };

    const _buildName = () => {
        return (
            <Form.Field className="full-width-field">
                <label>Cloud Name</label>
                <input
                    name="name"
                    className={errors.name ? "invalid-input-field" : ""}
                    {...register("name", { required: true, maxLength: 128 })}
                    placeholder="Name"
                    value={state.tenantCloud.name || ''}
                    onChange={(e) => {
                        setState((prevState) => ({
                            ...prevState,
                            tenantCloud: { ...prevState.tenantCloud, name: e.target.value },
                        }));
                    }}
                />
                {errors.name && errors.name.type === "required" && (
                    <p className="validation-error">* Please enter a name</p>
                )}
                {errors.name && errors.name.type === "maxLength" && (
                    <p className="validation-error">
                        * Name may not be more than 128 characters long
                    </p>
                )}
            </Form.Field>
        );
    };

    const _buildDescription = () => {
        return (
            <Form.Field>
                <label>Cloud Description</label>
                <textarea
                    name="description"
                    className={errors.description ? "invalid-input-field" : ""}
                    {...register("description", { maxLength: 500 })}
                    placeholder="Description"
                    value={state.tenantCloud.description || ''}
                    onChange={(e) => {
                        setState((prevState) => ({
                            ...prevState,
                            tenantCloud: { ...prevState.tenantCloud, description: e.target.value },
                        }));
                    }}
                />
                {errors.description && errors.description.type === "maxLength" && (
                    <p className="validation-error">
                        * Description may not be more than 500 characters long
                    </p>
                )}
            </Form.Field>
        );
    };

    const _buildTenantSelection = () => {
        const tenantOptions = (props.availableTenants || [])
            .filter(tenant => !state.tenantCloud.tenants.some(t => t.id === tenant.id))
            .map(tenant => ({
                key: tenant.id,
                value: tenant,
                text: tenant.name
            }));

        return (
            <Form.Field>
                <label>Select Tenants</label>
                <Dropdown
                    placeholder='Select tenants to add to this cloud'
                    fluid
                    selection
                    options={tenantOptions}
                    value=""
                    closeOnChange={false}
                    onChange={(e, { value }) => {
                        if (value && e.type === 'click') {
                            setState((prevState) => ({
                                ...prevState,
                                tenantCloud: {
                                    ...prevState.tenantCloud,
                                    tenants: [...prevState.tenantCloud.tenants, value]
                                }
                            }));
                        }
                    }}
                />
            </Form.Field>
        );
    };

    const _buildQuestionnaireSelection = () => {
        const questionnaireOptions = (props.baseQuestionnaires || [])
            .filter(questionnaire => !state.tenantCloud.questionnaires.some(q => q.id === questionnaire.id))
            .map(questionnaire => ({
                key: questionnaire.id,
                value: questionnaire,
                text: questionnaire.name
            }));

        return (
            <Form.Field>
                <label>Assign Questionnaires</label>
                <Dropdown
                    placeholder='Select questionnaires to assign to this cloud'
                    fluid
                    selection
                    options={questionnaireOptions}
                    value=""
                    closeOnChange={false}
                    onChange={(e, { value }) => {
                        if (value && e.type === 'click') {
                            setState((prevState) => ({
                                ...prevState,
                                tenantCloud: {
                                    ...prevState.tenantCloud,
                                    questionnaires: [...prevState.tenantCloud.questionnaires, value]
                                }
                            }));
                        }
                    }}
                />
            </Form.Field>
        );
    };

    const _renderSelectedTenants = () => {
        if (state.tenantCloud.tenants.length === 0) {
            return (
                <Segment>
                    <Header>
                        <Icon name='building' color="grey" />
                        No tenants selected
                    </Header>
                </Segment>
            );
        }

        const selectedTenantDetails = state.tenantCloud.tenants;

        return (
            <Table compact size='small'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className='nectaPrimaryBg'>Tenant Name</Table.HeaderCell>
                        <Table.HeaderCell className='nectaPrimaryBg'>Tenant Description</Table.HeaderCell>
                        <Table.HeaderCell className='nectaPrimaryBg' />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {selectedTenantDetails.map((tenant, index) => (
                        <Table.Row key={`${tenant.id}.${index}`}>
                            <Table.Cell>{tenant.companyName}</Table.Cell>
                            <Table.Cell>{tenant.description}</Table.Cell>
                            <Table.Cell textAlign='right'>
                                <Button
                                    compact
                                    className='danger'
                                    icon='remove'
                                    size='small'
                                    onClick={() => {
                                        setState((prevState) => ({
                                            ...prevState,
                                            tenantCloud: {
                                                ...prevState.tenantCloud,
                                                tenants: prevState.tenantCloud.tenants.filter(t => t.id !== tenant.id)
                                            }
                                        }));
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        );
    };

    const _renderSelectedQuestionnaires = () => {
        if (state.tenantCloud.questionnaires.length === 0) {
            return (
                <Segment>
                    <Header>
                        <Icon name='clipboard list' color="grey" />
                        No questionnaires assigned
                    </Header>
                </Segment>
            );
        }

        const selectedQuestionnaireDetails = state.tenantCloud.questionnaires;

        return (
            <Table compact size='small'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className='nectaPrimaryBg'>Questionnaire Name</Table.HeaderCell>
                        <Table.HeaderCell className='nectaPrimaryBg'>Description</Table.HeaderCell>
                        <Table.HeaderCell className='nectaPrimaryBg' />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {selectedQuestionnaireDetails.map((questionnaire, index) => (
                        <Table.Row key={`${questionnaire.id}.${index}`}>
                            <Table.Cell>{questionnaire.name}</Table.Cell>
                            <Table.Cell
                                style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                title={questionnaire.description}
                            >
                                {questionnaire.description}
                            </Table.Cell>
                            <Table.Cell textAlign='right'>
                                <Button
                                    compact
                                    className='danger'
                                    icon='remove'
                                    size='small'
                                    onClick={() => {
                                        setState((prevState) => ({
                                            ...prevState,
                                            tenantCloud: {
                                                ...prevState.tenantCloud,
                                                questionnaires: prevState.tenantCloud.questionnaires.filter(q => q.id !== questionnaire.id)
                                            }
                                        }));
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        );
    };

    return (
        <Container>
            <Form
                size="small"
                onSubmit={handleSubmit(onSubmit)}
                style={{ paddingBottom: "20px" }}
            >
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            {_buildName()}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            {_buildDescription()}
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            {_buildTenantSelection()}
                            <h4>Selected Tenants:</h4>
                            {_renderSelectedTenants()}
                        </Grid.Column>
                        <Grid.Column width={8}>
                            {_buildQuestionnaireSelection()}
                            <h4>Assigned Questionnaires:</h4>
                            {_renderSelectedQuestionnaires()}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Divider />
                <Button.Group floated="right" style={{ marginBottom: "10px" }}>
                    <Button
                        className="danger"
                        onClick={() => {
                            if (_.isEmpty(props.onComplete)) {
                                props.onComplete();
                            }
                        }}
                    >
                        <Icon name="remove" /> Cancel
                    </Button>
                    <Button type="submit" className="success">
                        <Icon name="checkmark" /> Ok
                    </Button>
                </Button.Group>
            </Form>
        </Container>
    );
}

const mapStateToProps = (state, ownProps) => {
    let tenantCloud = {};
    let isNew = false;
    let newCloud = {
        name: '',
        description: '',
        tenants: [],
        questionnaires: []
    };

    if (ownProps.bdaction === 'add') {
        tenantCloud = newCloud;
        isNew = true;
    } else {
        tenantCloud = _.isEmpty(ownProps.cloud)
            ? newCloud
            : ownProps.cloud;
        isNew = false;
    }

    return {
        userPermissions: _.isEmpty(state.authUserRoles.permissions) ? {} : state.authUserRoles.permissions,
        isPermissionsFetched: state.isPermissionsFetched === true,
        tenant: state.tenantManagement.activeTenant,
        availableTenants: state.tenantManagement.allTenants || [],
        isNew: isNew,
        tenantCloud: tenantCloud,
        baseQuestionnaires: state.baseQuestionnaires || []
    }
}

export default connect(
    mapStateToProps,
    (dispatch) => ({
        saveTenantCloudAction: (cloud, isNew) => dispatch(TENANT_CLOUD_ACTIONS.saveTenantCloudAction(cloud, isNew)),
    })
)(TenantCloudDetails)
